import Firebase from 'firebase/app';
import 'firebase/database';
import "./wwfconfigs";


let config = {
  databaseURL: wwfconfigs.FIREBASE
}

Firebase.initializeApp(config);

export default {
  database: Firebase.database()
}


// WEBPACK FOOTER //
// ./src/firebase.js